
import {
  defineComponent, ref, computed, PropType,
} from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'primevue/dialog';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';
import type { ActionPayload, BillableMode, SetBillableResult } from './types';

export default defineComponent({
  name: 'SetBillableAction',

  components: {
    Dialog,
    SpmButton,
  },

  props: {
    /** 'billable' => rend facturable (do_not_charge=0) ; 'non_billable' => exclut (do_not_charge=1). */
    mode: {
      type: String as PropType<BillableMode>,
      required: true,
    },
  },

  emits: ['confirm'],

  setup(props, { emit, expose }) {
    const { t } = useI18n();

    const isVisible = ref(false);
    const currentPayload = ref<ActionPayload | null>(null);

    // Header dépend du sens (billable / non-billable) ET du contexte (lot / ligne).
    const dialogHeader = computed(() => {
      const base = props.mode === 'billable'
        ? 'myLists.actions.setBillable'
        : 'myLists.actions.setNonBillable';
      return currentPayload.value?.context === 'grouped'
        ? t(`${base}.headerGrouped`)
        : t(`${base}.headerRow`);
    });

    const open = (payload: ActionPayload) => {
      currentPayload.value = payload;
      isVisible.value = true;
    };

    const close = () => {
      isVisible.value = false;
      currentPayload.value = null;
    };

    const confirm = () => {
      if (!currentPayload.value) return;

      const result: SetBillableResult = {
        context: currentPayload.value.context,
        mode: props.mode,
        selectionInfo: currentPayload.value.selectionInfo,
        rowId: currentPayload.value.rowId,
      };

      emit('confirm', result);
      close();
    };

    expose({ open });

    return {
      t,
      isVisible,
      dialogHeader,
      close,
      confirm,
    };
  },
});
